<template>
<div class="chapter">
<div class="inner_page">
<div id="Contents">
<p class="toc-title"><b>Contents</b></p>
<table border="0" cellpadding="0" cellspacing="0" width="100%">
<colgroup>
<col width="25%"/>
<col width="75%"/>
</colgroup>
<tbody>
<tr>
<td align="left" colspan="2" valign="top"><p class="toc"><a href="#/xhtml/05_Maps_Diagrams"><i>Maps &amp; Diagrams</i></a></p></td>
</tr>
<tr>
<td align="left" colspan="2" valign="top"><p class="toc"><a href="#/xhtml/06_Acknowledgements"><i>Acknowledgements</i></a></p></td>
</tr>
<tr>
<td align="left" colspan="2" valign="top"><p class="toc"><a href="#/xhtml/07_Introduction"><i>Introduction</i></a></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><a href="#/xhtml/08_Chapter01"><b>Chapter 1</b></a></p></td>
<td align="left" valign="top"><p class="toc1a"><a href="#/xhtml/08_Chapter01">The Goths: Their Origins, Tribal Structure, Home Life and Warlike Ability</a></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><a href="#/xhtml/09_Chapter02"><b>Chapter 2</b></a></p></td>
<td align="left" valign="top"><p class="toc1a"><a href="#/xhtml/09_Chapter02">The Goths’ Part in the ‘Crisis of the Third Century’: And Roman-Gothic Relations Up To the Reign of Valens</a></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/10_Chapter03" title="Link target outside of Sample"><b>Chapter 3</b></span></p></td>
<td align="left" valign="top"><p class="toc1a"><span href="#/xhtml/10_Chapter03" title="Link target outside of Sample">Valens, Procopius, and the Goths</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/11_Chapter04" title="Link target outside of Sample"><b>Chapter 4</b></span></p></td>
<td align="left" valign="top"><p class="toc1a"><span href="#/xhtml/11_Chapter04" title="Link target outside of Sample">Valens’ Gothic Campaigns <span class="small">AD</span> 367–369</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/12_Chapter05" title="Link target outside of Sample"><b>Chapter 5</b></span></p></td>
<td align="left" valign="top"><p class="toc1a"><span href="#/xhtml/12_Chapter05" title="Link target outside of Sample">Crisis Beyond the Danube <span class="small">AD</span> 369–376</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/13_Chapter06" title="Link target outside of Sample"><b>Chapter 6</b></span></p></td>
<td align="left" valign="top"><p class="toc1a"><span href="#/xhtml/13_Chapter06" title="Link target outside of Sample"><span class="small">AD</span> 367–376 – Friends and Enemies</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/14_Chapter07" title="Link target outside of Sample"><b>Chapter 7</b></span></p></td>
<td align="left" valign="top"><p class="toc1a"><span href="#/xhtml/14_Chapter07" title="Link target outside of Sample"><span class="small">AD</span> 376 – The Beginning of the End</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/15_Chapter08" title="Link target outside of Sample"><b>Chapter 8</b></span></p></td>
<td align="left" valign="top"><p class="toc1a"><span href="#/xhtml/15_Chapter08" title="Link target outside of Sample">The Battle of the Willows: A Blueprint for Disaster?</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/16_Chapter09" title="Link target outside of Sample"><b>Chapter 9</b></span></p></td>
<td align="left" valign="top"><p class="toc1a"><span href="#/xhtml/16_Chapter09" title="Link target outside of Sample">The Roman Offensives <span class="small">AD</span> 377–378</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/17_Chapter10" title="Link target outside of Sample"><b>Chapter 10</b></span></p></td>
<td align="left" valign="top"><p class="toc1a"><span href="#/xhtml/17_Chapter10" title="Link target outside of Sample">The Calm Before the Storm: The Last Fateful Days Before the Battle of Adrianople, the Decisions Made and Why</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/18_Chapter11" title="Link target outside of Sample"><b>Chapter 11</b></span></p></td>
<td align="left" valign="top"><p class="toc1a"><span href="#/xhtml/18_Chapter11" title="Link target outside of Sample">9 August <span class="small">AD</span> 378: ‘The Day the Eagles Fell’</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/19_Chapter12" title="Link target outside of Sample"><b>Chapter 12</b></span></p></td>
<td align="left" valign="top"><p class="toc1a"><span href="#/xhtml/19_Chapter12" title="Link target outside of Sample">Aftermath</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/20_Chapter13" title="Link target outside of Sample"><b>Chapter 13</b></span></p></td>
<td align="left" valign="top"><p class="toc1a"><span href="#/xhtml/20_Chapter13" title="Link target outside of Sample">‘What If …’</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/21_Chapter14" title="Link target outside of Sample"><b>Chapter 14</b></span></p></td>
<td align="left" valign="top"><p class="toc1a"><span href="#/xhtml/21_Chapter14" title="Link target outside of Sample">The Location of the Battle of Adrianople</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/22_Chapter15" title="Link target outside of Sample"><b>Chapter 15</b></span></p></td>
<td align="left" valign="top"><p class="toc1a"><span href="#/xhtml/22_Chapter15" title="Link target outside of Sample">The Roman Empire and its Army During the Reign of Valens</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/23_Chapter16" title="Link target outside of Sample"><b>Chapter 16</b></span></p></td>
<td align="left" valign="top"><p class="toc1a"><span href="#/xhtml/23_Chapter16" title="Link target outside of Sample">Biographies</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/24_Chapter17" title="Link target outside of Sample"><b>Chapter 17</b></span></p></td>
<td align="left" valign="top"><p class="toc1a"><span href="#/xhtml/24_Chapter17" title="Link target outside of Sample">The Sources</span></p></td>
</tr>
<tr>
<td align="left" colspan="2" valign="top"><p class="toc1"><span href="#/xhtml/25_Abbreviations" title="Link target outside of Sample"><i>Abbreviations</i></span></p></td>
</tr>
<tr>
<td align="left" colspan="2" valign="top"><p class="toc"><span href="#/xhtml/26_Notes" title="Link target outside of Sample"><i>Notes</i></span></p></td>
</tr>
<tr>
<td align="left" colspan="2" valign="top"><p class="toc"><span href="#/xhtml/27_Bibliography" title="Link target outside of Sample"><i>Bibliography</i></span></p></td>
</tr>
</tbody>
</table>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Contents.vue?0561b1c5